var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99935,
    cy: 5.33333,
    r: 2.66667,
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 13.0794C2.66602 10.2741 4.94012 8 7.74538 8H8.25332C11.0586 8 13.3327 10.2741 13.3327 13.0794C13.3327 13.2196 13.219 13.3333 13.0787 13.3333H2.91998C2.77972 13.3333 2.66602 13.2196 2.66602 13.0794Z",
    stroke: "#7F7F84",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.449cae80b891f4b74b1f7022a6b33e84.svg";
export { ForwardRef as ReactComponent };